import React from 'react';
import './avatar.css';

interface AvatarProps {
  initials: string;
  size?: number;
}

export const Avatar: React.FC<AvatarProps> = ({ initials, size = 32 }) => (
  <div
    className="cb-avatar"
    style={{ width: size, height: size, fontSize: size * 0.375 }}
    aria-hidden="true"
  >
    {initials}
  </div>
);
